import { NotesListController } from '../controller/NotesListController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class NotesListWebComponent extends BaseWebComponentElement {
  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: NotesListController,
    });
  }
}
